(ns dre.page-util
  (:import
   [goog.async Debouncer])
  (:require
   ["numeral" :as numeral]
   [clj-commons.humanize :refer [intcomma]]
   [clojure.string :as str]
   [markdown.core :as md]
   [dre.shared.interface.search.pills :as pills-util]))

(defn strip-zerowidth-utf8
  [s]
  (str/replace s #"(^[\s\u200b]*|[\s\u200b]*$)" ""))

(defn suggested-uri?
  [uri]
  (boolean
   (when uri
     (or (re-find #"default#" uri)
         (re-find #"acronym#" uri)
         (re-find #"suggested#" uri)))))

(defn ceil
  [x]
  (.ceil js/Math x))

(defn floor
  [x]
  (.floor js/Math x))

(defn round
  [x]
  (.round js/Math x))

(defn short-num
  [num]
  (.format (numeral num) "0a"))

(defn enum
  [s]
  (map vector (range) s))

(def nbsp "No break space" "\u00a0")

(defn capitalize-words
  [s]
  (->> (str/split (str s) #"-")
       (map str/capitalize)
       (str/join " ")))

(defn parse-int
  [s]
  (js/parseInt s 10))

(defn intword
  [x]
  (let [x (if (integer? x) x (parse-int x))]
    (cond (< x 100) (.toFixed (float x) 1)
          (< x 1000) (str (.toFixed (float (/ x 100)) 1) " hundred")
          (< x 100000) (str (.toFixed (float (/ x 1000)) 1) " thousand")
          (< x 1000000) (str (.toFixed (float (/ x 100000)) 1) " hundred thousand")
          (< x 1000000000) (str (.toFixed (float (/ x 1000000)) 1) " million")
          :else (intcomma x))))

(defn percentage
  [num]
  (.format (numeral num) "0.0%"))

(defn around
  ([x]
   (around x 1000000))
  ([x max]
   (if (> x max)
     (intword x)
     (intcomma x))))

(defn query-params
  "Returns a query params map from a given params map which can
  be either a route-params map or a query params map itself."
  [params]
  (or (:query-params params) params))

(def langs #{"eng" "en" "en-us"})

(defn strip-lang
  [v]
  (if (or (empty? v) (vector? v))
    (remove #(langs %) v)
    (remove #(langs %) [v])))

(defn dangerous
  ([comp content]
   (dangerous comp nil content))
  ([comp props content]
   #_(when (str/includes? content "sense")
       (debug "dangerous content" content))
   [comp (assoc props :dangerouslySetInnerHTML {:__html content})]))

(defn md [s]
  (dangerous :div (md/md->html s)))

(defn truncate
  [text max-len & {:as opts}]
  (if (< max-len (count text))
    (str (subs text 0 max-len) "…" (:hint opts))
    text))

(defn unescape
  "Hacky way of removing escaped html entities"
  [s]
  (try
    (js/decodeURIComponent s)
    (catch :default _
      s)))

(defn lower
  "Returns lowercased x, or nil if x is nil."
  [x]
  (when x
    (str/lower-case x)))

;; from https://crossclj.info/ns/fullcontact/full.core/0.10.2/full.core.sugar.html
(defn insert-at
  [s idx i]
  (if (= idx -1)
    (vec (concat s i))
    (let [[before after] (split-at idx s)]
      (vec (concat before i after)))))

(defn remove-at
  "Returns the sequence s with the element at 0-based index
  idx removed."
  [s idx]
  (let [vec-s (vec s)]
    (into (vec (take idx vec-s)) (nthrest vec-s (inc idx)))))

(defn debounce2
  [f ms]
  (let [debouncer (Debouncer. f ms)]
    (fn [& args] (.apply (.-fire debouncer) debouncer (to-array args)))))

(defn count-pills
  [pills]
  (->> pills
       pills-util/pills->flats
       pills-util/main-pills
       count))
